import { curry } from 'lib/util'

/**
 * Log Event Handler
 *
 * Prints a message to the console.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Event} event                 the event object that triggered this handler
 */
const logClick = async (module, component, event) => {
  console.log('Clicked', event?.detail)
}

export default curry(logClick)
